import { createContext } from 'react';
import { FavoriteToggleContextType } from '#baseMenu/components';

const FavoriteToggleContext = createContext<FavoriteToggleContextType>(null);

export { FavoriteToggleContext };
